import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 40px);
`;
